import React, { useState, useEffect, useRef } from "react";
import MDBox from "components/MDBox";
import SettingsIcon from "@mui/icons-material/Settings";
import TrackChangesIcon from "@mui/icons-material/TrackChanges";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import Slide23 from "assets/images/TheSolutionImages/Slide2/Slide23.png";

function Slide2() {
  const [showScrollIcon, setShowScrollIcon] = useState(false);
  const scrollRef = useRef();

  useEffect(() => {
    const handleResize = () => {
      const isSmallScreen = window.innerWidth < 1300;

      const isIpadProLandscape =
        window.innerWidth >= 1350 &&
        window.innerWidth <= 1370 &&
        window.innerHeight >= 1000 &&
        window.innerHeight <= 1050;

      setShowScrollIcon(isSmallScreen || isIpadProLandscape);
    };

    handleResize(); // run once on mount
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <MDBox textAlign="left" px={{ xs: 2, md: 4 }} width="100%">
      <MDBox
        width="100%"
        maxWidth={{ xs: "100%", md: "95%", lg: "1320px" }}
        height={{ xs: "auto", md: "540px" }}
        margin="0 auto"
        display="flex"
        flexDirection={{ xs: "column", md: "row" }}
        alignItems={{ xs: "flex-start", md: "center" }}
        justifyContent="space-between"
        gap={4}
        px={{ xs: 2, md: 3 }}
        py={3}
        sx={{
          backgroundColor: "rgba(0, 0, 0, 0)",
          borderRadius: "12px",
          color: "#FFFFFF",
          "*": {
            color: "#FFFFFF !important",
          },
        }}
      >
        {/* Scrollable Text Block */}
        <MDBox
          flex="1"
          display="flex"
          flexDirection="column"
          height="100%"
          maxHeight="100%"
          pr={1}
          justifyContent="flex-start"
        >
          <h1
            style={{
              fontSize: "clamp(24px, 5vw, 32px)",
              fontWeight: "bold",
              marginBottom: "16px",
            }}
          >
            Why Field Digitalization Matters
          </h1>

          <MDBox
            ref={scrollRef}
            fontSize={{ xs: "18px", md: "24px" }}
            lineHeight={1.6}
            sx={{
              overflowY: "auto",
              maxHeight: { xs: "300px", md: "none" },
              pr: 1,
              scrollbarWidth: "none",
              msOverflowStyle: "none",
              "&::-webkit-scrollbar": {
                display: "none",
              },
            }}
          >
            <MDBox mb={2} style={{ fontSize: "24px" }}>
              Field digitalization creates a real-time conduit for operational performance data to
              flow directly to reserve stakeholders, without filters or delays.
            </MDBox>

            <MDBox mb={2}>
              <MDBox display="flex" alignItems="center" mb={1}>
                <TrackChangesIcon sx={{ mr: 1.5, fontSize: 36 }} />
                <strong style={{ fontSize: "24px" }}>Foundation for Production Optimization</strong>
              </MDBox>
              <MDBox style={{ fontSize: "20px" }}>
                To maximize availability, the first step is to see clearly. SharpWatch® provides{" "}
                unbiased, real-time visibility into field behavior highlighting losses, risks, and
                hidden opportunities as they emerge.
              </MDBox>
            </MDBox>

            <MDBox>
              <MDBox display="flex" alignItems="center" mb={1}>
                <SettingsIcon sx={{ mr: 1.5, fontSize: 36 }} />
                <strong style={{ fontSize: "24px" }}>Empowering Proactive Oversight</strong>
              </MDBox>
              <MDBox style={{ fontSize: "20px" }}>
                SharpWatch® and the cloud connectivity deliver immediate insights, reducing
                dependency on manual reporting or delayed intervention.
              </MDBox>
            </MDBox>
          </MDBox>

          {/* Scroll Icon OUTSIDE of scrollable area */}
          {showScrollIcon && (
            <MDBox
              display="flex"
              justifyContent="center"
              alignItems="center"
              mt={2}
              sx={{
                animation: "bounce 1.5s infinite",
                fontSize: "30px",
                color: "#FFFFFF",
              }}
            >
              <KeyboardArrowDownIcon fontSize="inherit" />
            </MDBox>
          )}
        </MDBox>

        {/* Right Image */}
        <MDBox
          display="flex"
          justifyContent="center"
          alignItems="center"
          width={{ xs: "100%", md: "40%" }}
          maxWidth={{ xs: "100%", md: "400px" }}
        >
          <img
            src={Slide23}
            alt="Field Digitalization"
            style={{
              width: "100%",
              height: "auto",
              borderRadius: "16px",
              objectFit: "contain",
            }}
          />
        </MDBox>
      </MDBox>

      {/* Bounce Animation */}
      <style>
        {`
          @keyframes bounce {
            0%, 100% { transform: translateY(0); }
            50% { transform: translateY(6px); }
          }
        `}
      </style>
    </MDBox>
  );
}

export default Slide2;
